import { Authorization } from '../../core/authorization';

export const isFieldDisabled = (auth: Authorization) => {
    if (auth.canUpdateFarmVisit && auth.canViewFarmVisitsProducer) return false;
    else if (auth.canUpdateFarmVisit && auth.canViewFarmVisitsProducer === false) return false;
    else if (auth.canViewFarmVisitsProducer) return true;
    return true;
};
